/** Make /uploads/... paths absolute for display (admin editor / storefront). */
export function enrichHtmlMediaUrls(html: string, apiOrigin?: string): string {
  if (!html || !apiOrigin) return html || ''
  const origin = apiOrigin.replace(/\/$/, '')
  return html.replace(
    /(src|href)=(["'])(\/uploads\/[^"']+)\2/gi,
    (_match, attr: string, quote: string, path: string) =>
      `${attr}=${quote}${origin}${path}${quote}`,
  )
}

/** Prefer portable /uploads/... paths when saving HTML to the database. */
export function portableHtmlMediaUrls(html: string, apiOrigin?: string): string {
  if (!html) return ''
  let next = html
  if (apiOrigin) {
    const origin = apiOrigin.replace(/\/$/, '')
    next = next.replaceAll(`${origin}/uploads/`, '/uploads/')
  }
  return next
}
